module.exports = __webpack_public_path__ + "static/media/medkit.04a4db89.svg";